import { render, staticRenderFns } from "./_.vue?vue&type=template&id=c8fbd552"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"
import style0 from "./_.vue?vue&type=style&index=0&id=c8fbd552&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonRichText: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/RichText.vue').default})
